import React from 'react';
import PropTypes from 'prop-types';
// External components
import { Row, Col } from 'react-simple-flex-grid';
// Internal components
import Image from '../Image/Image.jsx';
import Eyebrow from '../Eyebrow/Eyebrow.jsx';
import Header from '../Header/Header.jsx';
import Icon from '../Icon/Icon.jsx';
import GoToLink from '../GoToLink/GoToLink.jsx';
import Location from '../Location/Location.jsx';
// Styles
import './Tile.css';

const NAME = 'tile';

const Tile = ({
    src,
    classOverride,
    icon,
    eyebrow,
    title,
    link,
    linkText,
    bkgColor,
    location,
    actionUrl
}) => {
    const color = (bkgColor === 'white' || bkgColor === 'grey') ? '#525252' : 'white';
    return (
        <Row className={`${NAME} ${classOverride} ${NAME}-${bkgColor}`}>
            <a href={actionUrl} className={`${NAME}-link-container`}>
                {src && <Image src={src} fluid />}
                <div className={`${NAME}-content`}>
                    {icon && <Icon name={icon} color={color} />}
                    {eyebrow && <Eyebrow color={color}>{eyebrow}</Eyebrow>}
                    {title && <Header color={color} As="h6">{title}</Header>}
                    {location && <Location description={location} />}
                    {link && <GoToLink color={color} type={link} >{linkText}</GoToLink>}
                </div>
            </a>
        </Row>
    )
}

Tile.defaultProps = {
    src: null,
    classOverride: '',
    icon: null,
    eyebrow: null,
    title: null,
    link: null,
    linkText: null,
    bkgColor: null,
    location: null,
    actionUrl: null
};

Tile.propTypes = {
    // Image
    src: PropTypes.string,
    // Custom class
    classOverride: PropTypes.string,
    // eyebrow
    icon: PropTypes.string,
    // Text
    eyebrow: PropTypes.string,
    // Title
    title: PropTypes.string,
    // Link
    link: PropTypes.string,
    // Link Text
    linkText: PropTypes.string,
    // Tile bkg color
    bkgColor: PropTypes.string,
    // Location tag
    location: PropTypes.string,
    // on Tile click url
    actionUrl: PropTypes.string
};
export default Tile;
